import { default as SimpleKeyboard } from 'simple-keyboard';
import { KeyboardLayoutObject } from 'simple-keyboard/build/types/interfaces';

import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './keyboard.scss';

interface IKeyboardLayouts {
    [key: string]: KeyboardLayoutObject;
}

export default class Keyboard extends Component {
    public static initSelector: string = '.keyboard';

    public target: JQuery;
    public layout: string;
    public closeButton: JQuery;
    public keyboard: SimpleKeyboard;
    public selectedInput: JQuery;
    public currentLayoutType: string = 'default';
    public layouts: IKeyboardLayouts;

    constructor(target: HTMLElement) {
        super(target);

        if (Helpers.isLightWeightMode()) {
            this.layout = this.element.attr('data-layout');
            this.closeButton = this.element.find('.keyboard__close');

            // Close button click event
            this.closeButton.on('click touchstart', this.hide.bind(this));

            // Focus event
            $(document).on('focus', 'input.textfield__input', this.onInputFocus.bind(this));

            // Language change event
            $(document).on('keyboard.language', this.changeLanguage.bind(this));

            this.init();
        }
    }

    init(): void {
        this.layouts = {
            en: {
                default: [
                    '1 2 3 4 5 6 7 8 9 0 {bksp}',
                    'q w e r t y u i o p',
                    'a s d f g h j k l',
                    '{shift} z x c v b n m',
                    '. @ {space} € -',
                ],
                shift: [
                    '1 2 3 4 5 6 7 8 9 0 {bksp}',
                    'Q W E R T Y U I O P',
                    'A S D F G H J K L',
                    '{shift} Z X C V B N M',
                    '. @ {space} € -',
                ],
            },
            et: {
                default: [
                    '1 2 3 4 5 6 7 8 9 0 {bksp}',
                    'q w e r t y u i o p ü õ',
                    'a s d f g h j k l Ö Ä',
                    '{shift} z x c v b n m',
                    '. @ {space} € -',
                ],
                shift: [
                    '1 2 3 4 5 6 7 8 9 0 {bksp}',
                    'Q W E R T Y U I O P',
                    'A S D F G H J K L Ö Ä',
                    '{shift} Z X C V B N M',
                    '. @ {space} € -',
                ],
            },
            ru: {
                default: [
                    '\u0451 1 2 3 4 5 6 7 8 9 0 {bksp}',
                    '\u0439 \u0446 \u0443 \u043a \u0435 \u043d \u0433 \u0448 \u0449 \u0437 \u0445 \u044a',
                    '\u0444 \u044b \u0432 \u0430 \u043f \u0440 \u043e \u043b \u0434 \u0436 \u044d',
                    '{shift} \\ \u044f \u0447 \u0441 \u043c \u0438 \u0442 \u044c \u0431 \u044e',
                    '. @ {space} € -',
                ],
                shift: [
                    '\u0401 1 2 3 4 5 6 7 8 9 0 {bksp}',
                    '\u0419 \u0426 \u0423 \u041a \u0415 \u041d \u0413 \u0428 \u0429 \u0417 \u0425 \u042a',
                    '\u0424 \u042b \u0412 \u0410 \u041f \u0420 \u041e \u041b \u0414 \u0416 \u042d',
                    '{shift} \u042f \u0427 \u0421 \u041c \u0418 \u0422 \u042c \u0411 \u042e',
                    '. @ {space} € -',
                ],
            },
        };

        const backspace: string = '<svg class="keyboard__backspace-icon icon"><use xlink:href="' + gotoAndPlay.svgPath + '#backspace"></use></svg>';
        const shift: string = '[Shift]';
        const space: string = '<svg class="keyboard__spacebar-icon icon"><use xlink:href="' + gotoAndPlay.svgPath + '#spacebar"></use></svg>';

        this.keyboard = new SimpleKeyboard('.keyboard-element', {
            buttonTheme: [
                {
                    buttons: '{shift}',
                    class: 'keyboard__shift',
                },
                {
                    buttons: '{space}',
                    class: 'keyboard__spacebar',
                },
                {
                    buttons: '{bksp}',
                    class: 'keyboard__backspace',
                },
            ],
            display: {
                '{bksp}': backspace,
                '{shift}': shift,
                '{space}': space,
            },
            layout: this.layouts.et,
            layoutName: this.currentLayoutType,
            onChange: this.onChange.bind(this),
            onKeyPress: this.onKeyPress.bind(this),
            onRender: this.onRender.bind(this),
            theme: 'hg-theme-default hg-layout-default keyboard__keyboard',
        });
    }

    show(event: JQuery.FocusEvent, input: JQuery): void {
        this.target = input;

        if (!input.is('select')) {
            this.element.addClass('is-active');
            $('body').addClass('has-active-keyboard');

            Helpers.scrollToTarget(input, input.outerHeight());
        }
    }

    hide(): void {
        // Remove target
        this.target = null;

        // Remove active class
        this.element.removeClass('is-active');
        $('body').removeClass('has-active-keyboard');
    }

    onInputFocus(event: JQuery.FocusEvent): void {
        this.selectedInput = $(event.currentTarget);

        const inputName: string = this.selectedInput.attr('name');

        this.keyboard.setOptions({inputName});

        this.show(event, this.selectedInput);
    }

    onChange(input: string): void {
        if (this.selectedInput) {
            this.selectedInput.val(input);
        }
    }

    onKeyPress(button: string): void {
        this.currentLayoutType = (button === '{shift}' && this.currentLayoutType === 'default' ? 'shift' : 'default');

        // Set keyboard layout
        this.keyboard.setOptions({
            layoutName: this.currentLayoutType,
        });
    }

    onRender(): void {
        // Remove default and shift class
        this.element.removeClass('is-default is-shift');

        // Add current layout class
        this.element.addClass('is-' + this.currentLayoutType);
    }

    changeLanguage(event: JQuery.Event, language: string): void {
        // Change keyboard language
        this.keyboard.setOptions({
            layout: this.layouts[language],
        });
    }
}
